/* "From the gang." customer reviews strip (home). Data: assets/gang-reviews-strip.json (Mack's checked set,
   design-customer-photos @ 0ab1de4; text = Loox review field, never edited). Never calls Loox's feed. */
(function (root) {
  'use strict';
  var CLAMP_CHARS = 220;
  var MIN_REVIEWS = 3;

  /* Displayed text: the review exactly as posted; only surrounding whitespace is dropped (it is invisible). */
  function shownText(r) { return typeof (r && r.text) === 'string' ? r.text.trim() : ''; }

  /* Has a photo + text. Nothing else is filtered (any rating is shown as it is). */
  function usable(r) {
    return !!(r && typeof r.image === 'string' && /^https:\/\//.test(r.image) && shownText(r) && typeof r.reviewer === 'string' && r.reviewer);
  }

  /* People wearing the shirt first (stable: keeps the JSON's newest-first order inside each group). */
  function order(list) {
    return list.map(function (r, i) { return { r: r, i: i }; })
      .sort(function (a, b) { return ((b.r.worn !== false) - (a.r.worn !== false)) || (a.i - b.i); })
      .map(function (x) { return x.r; });
  }

  function prepare(data) {
    var list = data && Array.isArray(data.reviews) ? data.reviews.filter(usable) : [];
    return list.length >= MIN_REVIEWS ? order(list) : [];
  }

  function needsClamp(text) { return String(text || '').trim().length > CLAMP_CHARS; }

  function stars(rating) {
    var n = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
    return { text: '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n), label: 'Rated ' + n + ' out of 5' };
  }

  var core = { prepare: prepare, order: order, usable: usable, needsClamp: needsClamp, shownText: shownText, stars: stars, CLAMP_CHARS: CLAMP_CHARS, MIN_REVIEWS: MIN_REVIEWS };
  if (typeof module === 'object' && module.exports) module.exports = core;
  if (typeof document === 'undefined') return;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function card(r, rootUrl, eager) {
    var a = el('article', 'gr-card');
    a.setAttribute('role', 'listitem');
    a.dataset.id = r.id || '';
    var ph = el('div', 'gr-ph');
    var img = el('img');
    img.src = r.image;
    img.alt = r.reviewer + (r.product ? ' wearing ' + r.product : '');
    img.width = 300; img.height = 375;
    img.decoding = 'async';
    img.loading = eager ? 'eager' : 'lazy';
    ph.appendChild(img);
    a.appendChild(ph);
    var bd = el('div', 'gr-bd');
    var st = stars(r.rating);
    var s = el('div', 'gr-stars', st.text);
    s.setAttribute('role', 'img'); s.setAttribute('aria-label', st.label);
    bd.appendChild(s);
    var q = el('p', 'gr-q');
    q.appendChild(el('span', 'gr-t', shownText(r)));
    bd.appendChild(q);
    if (needsClamp(r.text)) {
      q.classList.add('is-clamped');
      q.id = 'gr-q-' + (r.id || Math.random().toString(36).slice(2));
      var more = el('button', 'gr-more', 'Read more');
      more.type = 'button';
      more.setAttribute('aria-expanded', 'false');
      more.setAttribute('aria-controls', q.id);
      more.addEventListener('click', function () {
        var open = q.classList.toggle('is-clamped') === false;
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        more.textContent = open ? 'Show less' : 'Read more';
      });
      bd.appendChild(more);
    }
    var by = el('p', 'gr-by');
    by.appendChild(el('strong', 'gr-name', r.reviewer));
    if (r.verified === true) { by.appendChild(document.createTextNode(' ')); by.appendChild(el('span', 'gr-ver', 'Verified')); }
    if (r.product) {
      by.appendChild(document.createTextNode(' · '));
      if (r.handle) {
        var link = el('a', 'gr-prod', r.product);
        link.href = rootUrl.replace(/\/$/, '') + '/products/' + encodeURIComponent(r.handle);
        by.appendChild(link);
      } else by.appendChild(el('span', 'gr-prod', r.product));
    }
    bd.appendChild(by);
    a.appendChild(bd);
    return a;
  }

  // The product page's 'Their words' band builds the same cards from the design's own file (Design R1 n1).
  window.BG_GANG = { card: card, usable: usable };

  function init(sec) {
    var row = sec.querySelector('.gr-row');
    var dots = sec.querySelector('.gr-dots');
    var prev = sec.querySelector('.gr-arw[data-dir="-1"]');
    var next = sec.querySelector('.gr-arw[data-dir="1"]');
    var rootUrl = sec.dataset.root || '/';
    var raf = 0;

    function hide() { sec.classList.add('is-empty'); row.textContent = ''; }

    function cards() { return Array.prototype.slice.call(row.querySelectorAll('.gr-card')); }

    function step() {
      var c = cards();
      if (c.length < 2) return row.clientWidth;
      return c[1].offsetLeft - c[0].offsetLeft;
    }

    /* Whole cards that fit in the row: (width + one gap) / (card + gap). */
    function perView() {
      var gap = parseFloat(getComputedStyle(row).columnGap) || 0;
      return Math.max(1, Math.floor((row.clientWidth + gap + 2) / (step() || row.clientWidth)));
    }

    function update() {
      raf = 0;
      var max = row.scrollWidth - row.clientWidth;
      if (prev) prev.disabled = row.scrollLeft <= 2;
      if (next) next.disabled = row.scrollLeft >= max - 2;
      var s = step() || 1;
      var idx = row.scrollLeft >= max - 2 ? dots.children.length - 1 : Math.round(row.scrollLeft / s);
      for (var i = 0; i < dots.children.length; i++) dots.children[i].classList.toggle('on', i === idx);
    }

    function buildDots() {
      var n = cards().length;
      var visible = perView();
      var pages = Math.max(1, n - visible + 1);
      if (dots.children.length === pages) return update();
      dots.textContent = '';
      for (var i = 0; i < pages; i++) {
        var d = el('i');
        d.dataset.i = String(i);
        dots.appendChild(d);
      }
      update();
    }

    function relayout() {
      if (cards().length < MIN_REVIEWS) return hide();
      buildDots();
    }

    function scrollToX(x) {
      var smooth = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      row.scrollTo({ left: x, behavior: smooth ? 'smooth' : 'auto' });
    }

    function page(dir) {
      var per = perView();
      scrollToX(row.scrollLeft + dir * per * step());
    }

    /* T-684 weekly set (Chase 10-29): the shop metafield byrdgang.gang_reviews_week, written each Monday by
       jobs/gang-reviews-week from the checked customer-photo pool, is inlined by the snippet. Used when it has at least
       MIN_REVIEWS usable reviews; otherwise the theme's checked file (never an empty section). */
    var weekly = null;
    try { var w = sec.querySelector('script[data-gr-week]'); if (w) weekly = prepare(JSON.parse(w.textContent)); } catch (e) { weekly = null; }
    (weekly && weekly.length ? Promise.resolve({ reviews: weekly }) : fetch(sec.dataset.src, { credentials: 'omit' })
      .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); }))
      .then(function (data) {
        var list = prepare(data);
        if (!list.length) return hide();
        var frag = document.createDocumentFragment();
        list.forEach(function (r, i) {
          var c = card(r, rootUrl, false);
          c.querySelector('img').addEventListener('error', function () {
            c.remove();
            relayout();
          }, { once: true });
          frag.appendChild(c);
        });
        row.appendChild(frag);
        sec.classList.add('is-ready');
        relayout();
        row.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
        window.addEventListener('resize', function () { buildDots(); });
        if (prev) prev.addEventListener('click', function () { page(-1); });
        if (next) next.addEventListener('click', function () { page(1); });
        dots.addEventListener('click', function (e) {
          var d = e.target.closest('i');
          if (d) scrollToX(Number(d.dataset.i) * step());
        });
      })
      .catch(hide);
  }

  function boot() { document.querySelectorAll('[data-gang-reviews]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})(this);
